import React, { useContext } from "react"
import { IconButton } from "../../../../mp-shared-components/generic-shared-components/components"
import { FaIcon } from "../../../../mp-core/icons"
import TableStyleContext from "../TableStyleContext"

type Props = {
  expanded?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  className?: string
  "aria-label"?: string
}

const RowToggleButton: React.FC<Props> = ({
  expanded = false,
  onClick,
  className,
  "aria-label": ariaLabel
}) => {
  const { cx, classes } = useContext(TableStyleContext)

  return (
    <IconButton
      size="xsmall"
      onClick={onClick}
      className={cx(classes.expandButton, className)}
      aria-label={ariaLabel || (expanded ? "Collapse row" : "Expand row")}
      aria-expanded={expanded}
    >
      <FaIcon solid name={expanded ? "angle-down" : "angle-right"} />
    </IconButton>
  )
}

export default RowToggleButton
